import { render, staticRenderFns } from "./o-health-x4-sq.vue?vue&type=template&id=20b3e623&scoped=true"
import script from "./o-health-x4-sq.vue?vue&type=script&lang=js"
export * from "./o-health-x4-sq.vue?vue&type=script&lang=js"
import style0 from "./o-health-x4-sq.vue?vue&type=style&index=0&id=20b3e623&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3e623",
  null
  
)

export default component.exports